import { SearchRequest } from '../../ts/service/realEstateService.interface'

export enum MailAgentIntervalOptionsLabel {
    HOURLY = 'Stündlich',
    EVERY4HOURS = 'Alle vier Stunden',
    DAILY = 'Einmal am Tag',
}

export enum MailAgentIntervalOptionsValue {
    HOURLY = 'HOURLY',
    EVERY4HOURS = 'QUARTERLY',
    DAILY = 'DAILY',
}

export enum MailAgentTrackingVariant {
    STICKY = 'modal_sticky',
    DETAIL = 'modal_detail',
    LIST = 'list_modal',
    NO_RESULT = 'nulltreffer_modal',
    SEARCHBOX = 'searchbox_modal',
}

export interface MailAgentRequestParams extends SearchRequest {
    searchText: string
}
